import { Component, Input } from "@angular/core";

import type { ChatRuntimeController } from './chat-runtime.controller';

@Component({
  selector: "app-chat-session-dialog",
  templateUrl: "./chat-session-dialog.component.html",
  host: { style: "display: contents" },
  standalone: false
})
export class ChatSessionDialogComponent {
  @Input({ required: true }) view!: ChatRuntimeController;
}
